import { render, staticRenderFns } from "./TalentCenter.vue?vue&type=template&id=0f965c6b&scoped=true"
import script from "./TalentCenter.vue?vue&type=script&lang=js"
export * from "./TalentCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f965c6b",
  null
  
)

export default component.exports